import { all, takeLatest } from 'redux-saga/effects';

import * as actionTypes from '../actionTypes';

import { cancelSubscriptionWithOffer } from './cancelSubscriptionWithOffer';
import { changeCurrentSubscription } from './changeCurrentSubscription';
import { getDiscountSubscription } from './getDiscountSubscription';
import { makeSubscriptionCancelling } from './makeSubscriptionCancelling';
import { pollGetSubscriptions } from './pollGetSubscriptions';
import { requestPauseSubscription } from './requestPauseSubscription';
import { requestRestoreSubscription } from './requestRestoreSubscription';
import { requestResumeSubscription } from './requestResumeSubscription';
import { requestSetReminder } from './requestSetReminder';
import { resetSubscription } from './resetSubscription';
import { sendSubscriptionFeedback } from './sendSubscriptionFeedback';

export default function* watchSubscriptions() {
    yield all([
        takeLatest(actionTypes.FETCH_USER_SUBSCRIPTIONS_REQUEST, pollGetSubscriptions, undefined),
        takeLatest(actionTypes.CANCEL_SUBSCRIPTION, makeSubscriptionCancelling),
        takeLatest(actionTypes.SEND_SUBSCRIPTION_FEEDBACK, sendSubscriptionFeedback),
        takeLatest(actionTypes.UPDATE_SUBSCRIPTION, changeCurrentSubscription),
        takeLatest(actionTypes.FETCH_DISCOUNT_SUBSCRIPTION_REQUEST, getDiscountSubscription),
        takeLatest(actionTypes.RESTORE_SUBSCRIPTION, requestRestoreSubscription),
        takeLatest(actionTypes.PAUSE_SUBSCRIPTION, requestPauseSubscription),
        takeLatest(actionTypes.RESUME_SUBSCRIPTION, requestResumeSubscription),
        takeLatest(actionTypes.SET_REMINDER, requestSetReminder),
        takeLatest(actionTypes.CANCEL_SUBSCRIPTION_WITH_OFFER, cancelSubscriptionWithOffer),
        takeLatest(actionTypes.RESET_SUBSCRIPTION, resetSubscription),
    ]);
}
